import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-incoming-call',
  templateUrl: './incoming-call.component.html',
  styleUrls: ['./incoming-call.component.css']
})
export class IncomingCallComponent implements OnInit {
    phoneNo;

    public info?: Info;

    public itemsListFindPersons: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.phoneNo = this.stateService.getStateParams()['phoneno'];
    }

    private async loadInfo() {
        if (!!this.phoneNo) {
            this.info = (await this.datatask.Post(1359, { phoneno: this.phoneNo }))[0];
        }
    }

    private async loadFindPersons() {
        if (!this.info) return;

        return this.itemsListFindPersons = await this.datatask.Post(1125, { searchtext: this.info.phoneno });
    }

    private async init() {
        await this.loadInfo();
        this.loadFindPersons();
    }

    ngOnInit() {
        this.init();
    }
}

interface Info {
    phoneno: string;
}
